import styled from 'styled-components';
import { ButtonGroup, Paper } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
export const StyledButtonApply = styled(Button)`
  border-radius: 5px !important;
  background-color: ${props => props.disabled ? '#c6c7c8 !important' : '#1661a6 !important'};
  color: #fefefe !important;
  width: 85px !important;
  margin-right: 12px !important;
  min-width: 82px !important;
  height: 32px !important;
  border: none !important;
  line-height: 20px !important;
  font-size: 13px !important;
  &.MuiButton-root {
    text-transform: none;
  }
  &:hover {
    background: ${props => !props.disabled && '#1f84e1 !important'};
  }
`;
export const StyledButtonCancel = styled(Button)`
  min-width: 82px !important;
  height: 32px !important;
  background: #ffffff !important;
  border: 1px solid #005099 !important;
  color: #005099;
  border-radius: 5px !important;
  font-family: 'OpenSans-Regular';
  line-height: 20px !important;
  font-size: 13px !important;
  &.MuiButton-root {
    text-transform: none;
  }
  &:hover {
    color: #005099 !important;
  }
`;
export const StyledButtonGroup = styled(ButtonGroup)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 55px;
`;
export const StyledFilterCard = styled(Paper)`
  height: 64px !important;
  border: none !important;
  border-bottom: 1px solid #e3e3e3 !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const StyledFormedStringCard = styled(Paper)`
  && {
    border: none !important;
    border-bottom: 1px solid #e3e3e3 !important;
    overflow: auto;
    min-height: 50px;
    height: auto;
    padding: 9px 9px 9px;
    padding-left: 29px;
  }
`;
export const StyledFormedButton = styled(Button)`
  && {
    border-radius: 16px !important;
    color: #000000 !important;
    background-color: #dde1e6 !important;
    opacity: 0.7;
    margin-right: 7px;
    margin-top: 5px;
    margin-bottom: 8px;
    margin-left: 9px !important;
    font-family: 'OpenSans-Regular';
    text-transform: none;
  }
`;
export const TypographyText = styled(Typography)``;